import {Money, MoneyObject} from "../../stem-core/localization/Money";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";


@globalStore
export class Wallet extends BaseStore("Wallet", {}, MoneyObject) {
    @field(Number) userId: number;
    declare balance: number;

    getBalance(): Money {
        // TODO: rename for consistency for all MoneyObjects?
        return new Money(this.balance, this.getCurrency());
    }

    getAmount(): Money {
        return this.getBalance();
    }

    // TODO: this function should be deprecated
    static getWallet(): Wallet | undefined {
        return this.all()[0];
    }
}
